import getPaymentMethods from 'lib/payment/getPaymentMethods'
import config from '../../constants/config'

export default function shouldShowGiftCards(currencyCode: string) {
  return config.ENABLE_GIFT_CARD && config.ENABLE_GIFT_CARD_V2 && getPaymentMethods(currencyCode).includes('giftcard')
}
